import { Router } from "framework7/types";
import { createContext } from "react";

export type RouteProps = {
  f7route: Router.Route;
  f7router: Router.Router;
};

export const RouteContext = createContext<RouteProps | null>(null);
